"use strict";import{Tray as e}from"./src/Tray.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-tray",e);
//# sourceMappingURL=sp-tray.js.map
